import { Building, CreditCard, Wallet } from 'lucide-react';
import { useAccounts } from '@/hooks/useFinancialData';
import { formatBRL } from '@/lib/format';
import { SectionHeader } from '@/components/ui/SectionHeader';
import { EmptyState } from '@/components/ui/EmptyState';

function iconFor(institution: string | null) {
  if (!institution) return Wallet;
  const l = institution.toLowerCase();
  if (l.includes('bradesco') || l.includes('cartão') || l.includes('nubank') || l.includes('inter')) {
    return CreditCard;
  }
  return Building;
}

export function AccountsBalance() {
  const { accounts, loading } = useAccounts();

  return (
    <div className="card p-5 h-full">
      <SectionHeader
        title="Saldo por conta"
        subtitle={loading ? 'Carregando…' : accounts.length > 0 ? `${accounts.length} conta(s)` : 'Nenhuma conta cadastrada'}
      />
      {loading ? (
        <div className="space-y-3 mt-2">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-12 rounded-xl bg-surface-subtle animate-pulse" />
          ))}
        </div>
      ) : accounts.length === 0 ? (
        <EmptyState
          icon={Wallet}
          title="Nenhuma conta cadastrada"
          description="Importe seu extrato para criar a primeira conta automaticamente."
        />
      ) : (
        <ul className="divide-y divide-border">
          {accounts.map((a) => {
            const Icon = iconFor(a.institution);
            const negative = a.balance_cents < 0;
            return (
              <li key={a.id} className="py-3 flex items-center justify-between gap-3">
                <div className="flex items-center gap-3 min-w-0">
                  <div className="w-9 h-9 rounded-xl bg-brand-50 text-brand-700 flex items-center justify-center shrink-0">
                    <Icon className="w-4 h-4" />
                  </div>
                  <div className="min-w-0">
                    <p className="text-sm font-medium text-ink truncate">{a.name}</p>
                    <p className="text-xs text-ink-muted truncate">{a.institution ?? 'Caixa físico'}</p>
                  </div>
                </div>
                <span className={`tabular-nums text-sm font-semibold ${negative ? 'text-negative' : 'text-ink'}`}>
                  {formatBRL(a.balance_cents)}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
